/**
 * SmartRural Sync API
 * API para sincronizar los datos de Smartrural entre la aplciación móvil y el servidor.
 *
 * OpenAPI spec version: 1.1.0
 * Contact: victor@aidiapp.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CompanyForAdmin { 
    id?: number;
    name?: string;
    contactmail?: string;
    contactphone?: string;
    createDate?: number;
    themeConfiguration?: any;
    modulesConfiguration?: any;
    rootCompany?: boolean;
}
